$(document).ready(function () {
  $('.search_input').on('click', function () {
    $('body').addClass('body_overlay');
    $('.side_bar_search').toggleClass('active');
     $('.side_serach_input').focus();
   // $(this).toggleClass('active');
  });
      $('.mobile_nav').on('click', function () {
    $('body').toggleClass('custom_is_active');
  });
   $('.open_order_note').on('click', function () {
    $('.order_note_box').toggleClass('active_box');
     $('.open_overlay').toggleClass('open_active');
   // $(this).toggleClass('active');
  });
   $('.open_overlay').on('click', function () {
    $('.order_note_box').removeClass('active_box');
     $(this).removeClass('open_active');
  });

   $('.btn_save_all').on('click', function () {
    $('.order_note_box').removeClass('active_box');
     $('.open_overlay').removeClass('open_active');
  });

   $('.cart-container').on('click', function () {
      $('body').addClass('body_overlay');
    //  $('.overlay_body').addClass('main_overlay');
  });
  $('.overlay_body').on('click', function () {
    //$(this).removeClass('main_overlay');
    $('body').removeClass('body_overlay');
    $('.side_bar_search').removeClass('active');
    $('.order_note_box').removeClass('active_box');
     $('.open_overlay').removeClass('open_active');
  });
  // $('.cartclosebtn').on('click', function () {
  //   $('.cart-container').removeClass('active_link');
  // });
  $(document).on('click', '.cartclosebtn', function(e) {
    if (!$(e.target).is('.cart-container'))
      $('.cart-container').removeClass('active_link');
  });
  $(document).on('click', '.cartclosebtn', function(e) {
    if (!$(e.target).is('body'))
      $('body').removeClass('body_overlay');
  });
  $(document).on('click', '.overlay_body', function(e) {
    if (!$(e.target).is('body'))
      $('body').removeClass('body_overlay');
  });
   $(document).on('click', '.sidebar_flopen', function(e) {
    if (!$(e.target).is('body'))
      $('.custom_sidebar').addClass('active');
  });

  $(document).on('click', '.sidebar_flclose', function(e) {
    if (!$(e.target).is('body'))
      $('.custom_sidebar').removeClass('active');
  });
  

  if ($(window).width() < 960) {
  $(window).scroll(function(){
    if ($(this).scrollTop() > 1200) {
       $('.sticky_addtocart').addClass('addstickyactive');
    } else {
       $('.sticky_addtocart').removeClass('addstickyactive');
    }
});
}
else {
   $(window).scroll(function(){
    if ($(this).scrollTop() > 600) {
       $('.sticky_addtocart').addClass('addstickyactive');
    } else {
       $('.sticky_addtocart').removeClass('addstickyactive');
    }
});
}
  setTimeout(function () {
  $("#related_slider_data").slick({
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        arrows: false
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        dots: true,
        arrows: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
      });
  }, 6000);


  $(".blog-product-slider").slick({
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        arrows: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
      });
  
});


// $(document).ready(function() {
//     $('.maiin_filter .faceted-filter-group').click(function() {
//         // Check if the clicked tab is already active
//         if ($(this).hasClass('active_fillter')) {
//             // Remove 'active' class from the current tab
//             $(this).removeClass('active_fillter');
            
//             // Optionally hide all tab contents
//             $('.tab-content').hide();
//         } else {
//             // Remove 'active' class from all tabs
//             $('.faceted-filter-group').removeClass('active_fillter');
            
//             // Add 'active' class to the clicked tab
//             $(this).addClass('active_fillter');
            
//             // Hide all tab content
//             $('.tab-content').hide();
            
//             // Show the corresponding tab content
//             const target = $(this).data('target');
//             $(target).show();
//         }
//     });
// });

$(document).ready(function() {
    $('.maiin_filter .faceted-filter-group .faceted-filter-group-summary').click(function() {
        const parentDiv = $(this).closest('.maiin_filter .faceted-filter-group');
        
        // Remove 'active_fillter' class from all other parent divs
        $('.maiin_filter .faceted-filter-group').not(parentDiv).removeClass('active_fillter');
        
        // Toggle the class on the clicked parent div
        parentDiv.toggleClass('active_fillter');
    });
    
});

// function toggleDescription() {
//   var shortDescription = document.querySelector(".short-description");
//   var fullDescription = document.querySelector(".full-description");
//   var readMoreBtn = document.getElementById("read-more-btn");
//   var readLessBtn = document.getElementById("read-less-btn");

//   if (fullDescription.style.display === "none") {
//     // Show the full description
//     fullDescription.style.display = "inline";
//     shortDescription.style.display = "none";
//     readMoreBtn.style.display = "none";
//     readLessBtn.style.display = "inline";
//   } else {
//     // Show the short description
//     fullDescription.style.display = "none";
//     shortDescription.style.display = "inline";
//     readMoreBtn.style.display = "inline";
//     readLessBtn.style.display = "none";
//   }
// }


document.addEventListener("DOMContentLoaded", function () {
  const description = document.querySelector(".collection-description");
  const button = document.querySelector(".read-more-btn");

  if (description && button) {
    // Show the button only if content overflows
    if (description.scrollHeight > description.offsetHeight) {
      button.style.display = "block";

      button.addEventListener("click", function () {
        if (description.classList.contains("expanded")) {
          description.classList.remove("expanded");
          button.textContent = "Read More";
        } else {
          description.classList.add("expanded");
          button.textContent = "Read Less";
        }
      });
    }
  }
});


function toggleFilters() {
  var filters = document.getElementById("collection-filters");
  var sidebarblock = document.getElementById("main_full_collection");
  var showFiltersBtn = document.getElementById("show-filters-btn");
  var hideFiltersBtn = document.getElementById("hide-filters-btn");

  if (filters.classList.contains("filters-hidden")) {
    // Show the filters
    filters.classList.remove("filters-hidden");
    sidebarblock.classList.remove('sidebar-swap');
    sidebarblock.classList.add('sidebar-full');
    filters.classList.add("filters-visible");
    showFiltersBtn.style.display = "none";
    hideFiltersBtn.style.display = "inline-block";
  } else {
    // Hide the filters
    filters.classList.remove("filters-visible");
    filters.classList.add("filters-hidden");
    sidebarblock.classList.remove('sidebar-full');
    sidebarblock.classList.add('sidebar-swap');
    showFiltersBtn.style.display = "inline-block";
    hideFiltersBtn.style.display = "none";
  }
}



// document.getElementById('load-more').addEventListener('click', function () {
//   const button = this;
//   let currentPage = parseInt(button.getAttribute('data-page'), 10);
//   const totalProducts = parseInt(button.getAttribute('data-total'), 10);
//   const currentCount = document.getElementById('current-count');

//   fetch(`/collections/{{ collection.handle }}?page=${currentPage + 1}&view=ajax`)
//     .then((response) => response.text())
//     .then((data) => {
//       const productList = document.getElementById('product-list');
//       productList.insertAdjacentHTML('beforeend', data);

//       currentPage++;
//       button.setAttribute('data-page', currentPage);

//       // Update viewing count
//       const displayedProducts = productList.children.length;
//       currentCount.textContent = displayedProducts;

//       // Hide button if all products are loaded
//       if (displayedProducts >= totalProducts) {
//         button.style.display = 'none';
//       }
//     })
//     .catch((error) => console.error('Error loading more products:', error));
// });





document.addEventListener('DOMContentLoaded', function() {
  const stickyCart = document.querySelector('.sticky_addtocart');
  if (!stickyCart) return;

  const productTags = window.meta?.product?.tags || [];
  const productHandle = window.meta?.product?.handle || '';

  const hasQuoteTag = productTags.some(tag => tag.trim().toLowerCase() === 'add to quote');

  if (hasQuoteTag) {
    const rightSticky = stickyCart.querySelector('.right-sticky');
    if (rightSticky) {
      rightSticky.innerHTML = `<a href="/pages/quote-request?product=${productHandle}" class="quote-btn">
        Request a Quote
      </a>`;
    }
  }
});

$('.cust_crt').on('click', function () {
    $(this).toggleClass('active_link');
});




